import { Injectable, computed, signal } from '@angular/core';

/**
 * Tracks in-flight "save" HTTP requests (registration step saves, uploads,
 * and the slow /complete call) so the wizard footer can show a spinner and
 * disable its buttons while a save is running. A counter (not a boolean)
 * keeps the state correct when several saves overlap.
 */
@Injectable({ providedIn: 'root' })
export class SavingService {
  private readonly inFlight = signal(0);

  /** True while at least one save request is outstanding. */
  readonly isSaving = computed(() => this.inFlight() > 0);

  begin(): void {
    this.inFlight.update((n) => n + 1);
  }

  end(): void {
    this.inFlight.update((n) => Math.max(0, n - 1));
  }
}
